import React, { memo, useMemo } from 'react';
import { useInfoAggiuntivaMeta, useIsInfoAggActive } from 'features/sport/hooks';

import { KeyManagerSport } from 'features/sport';
import { ScommesseDropdownRecursive } from '../components/scommesseDropdownRecursive';
import { ScommesseTipoProps } from '../types';
import { SizeInfoAggiuntiva } from 'lib/api/sport/sportScommesseBySlugResponse';
import { Skeleton } from './Skeleton';
import { isTruthy } from 'utility/functions';

export const Scommessa = memo(function Scommessa(props: ScommesseTipoProps) {
  const { isEstesa, hasHeader, scommessaKey, showOnlyBilanciata, gtagAction } = props;

  const { headers, headersTrKey, sizeInfoAggiuntive } = useInfoAggiuntivaMeta(scommessaKey) ?? {};
  const isActive = useIsInfoAggActive(scommessaKey);
  const { tipoScommessaId } = useMemo(() => new KeyManagerSport(scommessaKey), [scommessaKey]);

  if (headers && tipoScommessaId && sizeInfoAggiuntive && isActive) {
    return (
      <ScommesseDropdownRecursive
        counter={0}
        isEstesa={isEstesa}
        disabled={showOnlyBilanciata}
        scommessaKey={scommessaKey}
        infoAggHeaders={headers}
        hasTitleHeader={isTruthy(hasHeader)}
        followBilanciata={showOnlyBilanciata}
        infoAggiuntivaKey={scommessaKey}
        sizeInfoAggiuntive={sizeInfoAggiuntive as Array<SizeInfoAggiuntiva>}
        infoAggHeadersTrKey={headersTrKey}
        infoTipoScommessaId={tipoScommessaId}
        gtagAction={gtagAction}
      />
    );
  }

  return <Skeleton {...props} />;
});
